import { ChevronLeft, ChevronRight } from "lucide-react";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation, Pagination } from "swiper/modules";
import { toYoutubeEmbed } from "../../helper/toYoutubeEmbed";

const VideoSwiper = ({ data = [], onClick }) => {
  const prevRef = React.useRef(null);
  const nextRef = React.useRef(null);

  if (!data?.length) return null;

  return (
    <div className="relative video-swiper group flex-1 -mt-[1px]">
      <button ref={prevRef} className="swiper-btn-prev" aria-label="Previous">
        <ChevronLeft size={22} strokeWidth={2.5} />
      </button>
      <button ref={nextRef} className="swiper-btn-next" aria-label="Next">
        <ChevronRight size={22} strokeWidth={2.5} />
      </button>

      <Swiper
        modules={[Navigation, Pagination]}
        slidesPerView={1}
        spaceBetween={16}
        loop={data.length > 1}
        pagination={{ clickable: true }}
        navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        className="!bg-white overflow-hidden h-full border border-orange-400 !rounded-none !rounded-b-2xl !rounded-tr-2xl"
      >
        {data.map((item) => (
          <SwiperSlide className="h-full !rounded-none" key={item.id}>
            
            <HeroVideoCard item={item} onArticleClick={() => onClick?.(item)} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

const HeroVideoCard = ({ item, onArticleClick }) => {
  const rawUrl = item?.embed_link || item?.post_url || "";
  const iframeUrl = toYoutubeEmbed(rawUrl);

  return (
    <article className="group relative cursor-pointer overflow-hidden bg-white  transition">
      <div className="relative">
        <div className="relative w-full aspect-[16/9] sm:aspect-[16/9] md:aspect-[16/9] lg:h-[400px] lg:aspect-auto  overflow-hidden">
          <iframe
            src={iframeUrl}
            title={item?.title || "Video"}
            className="absolute inset-0 w-full h-full "
            frameBorder="0"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>

        <div className="py-5 px-4 flex flex-col gap-2 h-[142px]">
          <h4 className="text-[16px] text-start font-semibold text-[#9d2e43] leading-snug tracking-tight">
            {item?.title}
          </h4>
          <p className="line-clamp-1 text-[14px] text-[#6a6868]">
            {item?.short_description}
          </p>
          <div className="pt-3 flex flex-wrap items-center gap-2 justify-between mt-auto">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onArticleClick?.(item);
              }}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-orange-50 text-orange-600 font-medium text-xs xl:text-sm hover:bg-orange-100 transition-colors w-auto"
            >
              Read More <span className="text-sm">→</span>
            </button>

            {item?.post_url && (
              <a
                href={item.post_url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-gray-100 text-gray-700 font-medium text-xs xl:text-sm hover:bg-gray-200 transition-colors w-auto"
              >
                Visit on Site <span className="text-sm">↗</span>
              </a>
            )}
          </div>
        </div>
      </div>
    </article>
  );
};



export default VideoSwiper;
